export const IRIS_PERSONALIZED_CONTENT_REQUEST = 'IRIS_PERSONALIZED_CONTENT_REQUEST';
export const IRIS_PERSONALIZED_CONTENT_SUCCESS = 'IRIS_PERSONALIZED_CONTENT_SUCCESS';
export const IRIS_PERSONALIZED_CONTENT_ERROR = 'IRIS_PERSONALIZED_CONTENT_ERROR';
